module.exports = __webpack_public_path__ + "static/avatar_default.d24baa5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/res/avatar_default.png
// module id = 172
// module chunks = 168707334958949